<template>
  <span>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Permissões a Usuários</h2>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <e-data-table
          ref="dataTable"
          :headers="headers"
          :items="usuarios"
          :total="total"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
        <br>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>

import { showError, showConfirm, retPermissao } from '@/utils'
import EDataTable from '@/components/EDataTable'
import usuarioService from '@/services/usuario'
// import programaService from '@/services/programa'
// import Formulario2 from './formulario'
export default {
  components: {
  //  Formulario2, EDataTable
    EDataTable
  },
  data () {
    return {
      usuarios: [],
      usuario: {},
      programas: [],
      total: 0,
      loading: false,
      headers: [
        { text: 'Usuário', value: 'nome', sortable: false },
        { text: 'Ativo', value: 'ativo', sortable: false }
      ],
      modal: false,
      valid: true,
      rules: {
        descr: [v => !!v || 'Campo Requerido']
      }
    }
  },
  async mounted () {
    // let result = await programaService.getAll()
    // this.programas = result.data
  },
  methods: {
    async getAll (page, search) {
      try {
        const result = search === '' ? await usuarioService.getAll(page) : await usuarioService.getByNome(search, page)
        // let result = await usuarioService.getAll(page)
        this.total = result._meta.total_items
        this.usuarios = result.data
      } catch (error) {
        showError(error)
      }
    },
    editItem (item) {
      this.usuario = item
      var ret = retPermissao('Permissões', 'alterar')
      if (ret === true) {
        this.$router.push(`/permissoes/editar/${item.nome}`)
      }
    },
    async deleteItem (item) {
      var ret = retPermissao('Permissões', 'excluir')
      if (ret === true) {
        showConfirm('Tem certeza?', async result => {
          if (result) {
            try {
              await usuarioService.delete(item.id)
              this.$refs.dataTable.refresh()
            } catch (error) {
              showError(error)
            } finally {
              this.modal = false
            }
          }
        })
      }
    }
  }
}
</script>
